<template>
  <div class="el-container">
    <img @load="handleImgLoad()" class="nesc_nd1_li" :src="require('../../assets/image/home/companyProfile.jpg')" />
    <div :class="{show: textShow, en: lang === 'en'}" class="flex-column-left text-content">
      <h1>{{ $t('lang.companyProfile') }}</h1>
      <div>{{ $t('lang.companyProfileInfo') }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CompanyProfile',
  components: {
  },
  data: () => {
    return {
      lang: '',
      textShow: false
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    const lang = window.sessionStorage.getItem('language')
    this.lang = lang
  },
  updated() {},

  destroyed() {},

  methods: {
    handleImgLoad() {
      this.textShow = true
    }
  }
}
</script>

<style lang="scss">
//.el-main {
//  height: auto !important;
//  display: block;
//  @media screen and (max-width: 993px) {
//    min-height: calc(100vh - 60px) !important;
//  }
//  @media screen and (max-width: 767px) {
//    min-height: calc(100vh - 60px) !important;
//  }
//}
</style>
<style scoped lang="scss">
.el-container {
  position: relative;
}
.nesc_nd1_li {
  position: relative;
  height: calc(100vh - 64px);
  @media screen and (max-width: 992px) {
    height: auto;
  }
}
.nesc_list_png {
  width: 100%;
  height: 100%;
}

.text-content {
  letter-spacing: 2px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  height: 100%;
  position: absolute;
  color: #ffffff;
  width: 46%;
  padding-left: 4%;
  padding-right: 4%;
  div {
    text-indent: 2em;
  }
  visibility: hidden;
  &.show {
    visibility: visible;
  }
  @media screen and (min-width: 993px){
    h1 {
      font-size: 40px;
    }
    div {
      margin-top: 10%;
      font-size: 18px;
      line-height: 36px;
    }
    &.en {
      h1 { font-size: 32px; }
      div { font-size:  15px}
    }
  }

  @media screen and (min-width: 1200px){
    h1 {
      font-size: 40px;
    }
    div {
      font-size: 20px;
      line-height: 40px;
    }
    &.en {
      h1 { font-size: 32px; }
      div { font-size:  16px}
    }
  }

  @media screen and (min-width: 1920px){
    h1 {
      font-size: 40px;
    }
    div {
      font-size: 24px;
      line-height: 48px;
    }
    &.en {
      h1 { font-size: 32px; }
      div { font-size:  18px}
    }
  }

  @media screen and (max-width: 992px) {
    position: relative;
    width: 100%;
    color: #000000;
    margin-top: 40px;
    align-items: center;
    div {
      margin-top: 20px;
      margin-bottom: 20px;
      line-height: 40px;
      padding-left: 20px;
      padding-right: 20px;
    }
  }
  @media screen and (max-width: 768px) {
    position: relative;
    width: 100%;
    color: #000000;
    margin-top: 40px;
    align-items: center;
    div {
      margin-top: 20px;
      margin-bottom: 20px;
      line-height: 30px;
      padding-left: 10px;
      padding-right: 10px;
    }
  }
}

</style>
